import apiClient from "./client";
import { unwrapApiResponse } from "../utils/apiError";

export const teacherAPI = {
  getMe: async () => {
    const response = await apiClient.get("/teacher/me");
    return unwrapApiResponse(response);
  },

  getStatistics: async () => {
    const response = await apiClient.get("/teacher/statistics");
    return unwrapApiResponse(response);
  },

  getReviewCounts: async () => {
    const response = await apiClient.get("/teacher/review-counts");
    return unwrapApiResponse(response);
  },
};
